import { useSelector } from 'react-redux'
import styled from 'styled-components'

import Container from '@/components/layout/Container'
import Alert from '@/components/common/Alert'
import { userApi } from '@/common/services/api'
import { useActions } from '@/hooks/useActions'
import React from 'react'
import { device } from '@/common/constants/device'
import Footer from '@/components/layout/Footer'
import Header from '@/components/layout/Header'
import { useRouter } from 'next/router'
import { userAmplitudeAnalytics } from '@/common/services/userAmplitudeAnalytics'
import { ANALYTIC_OFFER } from '@/common/constants/analytics'
import { PAYMENT_SOURCE } from '@/common/constants/cookies'
import { SUBSCRIPTION_DEMO } from '@/common/constants/payments'
import { useTranslations } from 'next-intl'

const Wrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: ${({ bgColor }) => bgColor && `var(--${bgColor})`};
  background: ${({ isBackgroundGradient }) =>
    isBackgroundGradient &&
    `radial-gradient(289.85% 43.32% at 100% 45.17%, rgba(255, 235, 51, 0.52) 0%, rgba(0, 0, 0, 0.22) 100%), radial-gradient(107.67% 32.5% at 76.4% 59.57%, rgba(255, 134, 66, 0.66) 0%, rgba(0, 0, 0, 0.28) 100%), radial-gradient(458.24% 235.98% at 235.33% 63.52%, rgba(106, 103, 218, 0.20) 0%, rgba(0, 0, 0, 0.09) 100%), radial-gradient(243.3% 21.66% at 31.85% 96.96%, rgba(97, 71, 255, 0.73) 0%, rgba(0, 0, 0, 0.31) 100%), radial-gradient(275.64% 81.34% at 0% 53.28%, #FF8642 0%, rgba(0, 0, 0, 0.43) 30%), #0E0E0E`};

  @media ${device.laptop} {
    background: ${({ isBackgroundGradient }) =>
      isBackgroundGradient &&
      `radial-gradient(42.93% 74.57% at 73.76% 95.59%, rgba(255, 235, 51, 0.52) 0%, rgba(0, 0, 0, 0.22) 100%),
       radial-gradient(33.65% 79.88% at 51.09% 86.4%, rgba(255, 134, 66, 0.66) 0%, rgba(0, 0, 0, 0.28) 100%),
       radial-gradient(38.62% 73.98% at 68.54% 94.66%, rgba(106, 103, 218, 0.20) 0%, rgba(0, 0, 0, 0.09) 100%),
       radial-gradient(37.55% 71.65% at 31.85% 96.96%, rgba(97, 71, 255, 0.73) 0%, rgba(0, 0, 0, 0.31) 100%),
       radial-gradient(40.36% 95.9% at 50% 70.37%, #FF8642 0%, rgba(0, 0, 0, 0.43) 100%),
       #0E0E0E`};
  }

  &.search-page .container {
    padding-left: 0;
    padding-right: 0;

    @media ${device.tablet} {
      padding-left: 20px;
      padding-right: 20px;
    }
  }
`

function DefaultLayout({
  children,
  isFooterNone,
  isPaddingNone,
  isAlert = true,
  isContainerFullWidth,
  bgColor,
  isCenteredContent = true,
  className = '',
  isAutoMargin = true,
  isBackgroundGradient = false,
  experimentKey,
  addFooter,
}) {
  const subscription = useSelector((store) => store.user.subscription || {})
  const { user } = useSelector((state) => state.user)
  const { addNotification } = useActions()
  const t = useTranslations()
  const router = useRouter()

  const resendVerify = async () => {
    try {
      await userApi.resendUserVerifyEmail()
      addNotification({
        type: 'success',
        text: 'common.mainSuccess',
      })
    } catch (e) {
      addNotification({
        type: 'error',
        text: 'common.mainError',
      })
      console.error(e)
    }
  }

  const handleClick = () => {
    sessionStorage.setItem(PAYMENT_SOURCE, 'sticky_banner')
    userAmplitudeAnalytics.trackEvent(`${ANALYTIC_OFFER}_header_banner_clicked`)
    router.push('/premium')
  }

  const shouldShowComponent =
    isAlert && subscription?.name === SUBSCRIPTION_DEMO

  return (
    <Wrapper
      className={className}
      bgColor={bgColor}
      isBackgroundGradient={isBackgroundGradient}
    >
      <Header experimentKey={experimentKey} />
      <Container
        isContainerFullWidth={isContainerFullWidth}
        isCentered={isCenteredContent}
        isAutoMargin={isAutoMargin}
        className="container"
        isPaddingNone={isPaddingNone}
      >
        {shouldShowComponent && (
          <Alert
            className="mb-3"
            text={t('common.alertText')}
            btnText={t('common.alertButtonText')}
            handleClick={handleClick}
          />
        )}
        {isAlert && user && !user.is_verified && (
          <Alert
            btnText={t('common.ResendEmail')}
            handleClick={resendVerify}
            text={t('common.pleaseVerifyEmail')}
          />
        )}
        {children}
      </Container>
      {addFooter}
      {isFooterNone ?? <Footer />}
    </Wrapper>
  )
}

export default DefaultLayout
